import Icon from './Icon';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function BuyStrip() {
  return (
    <section className="section buy buy--warm" id="buy">
      <div className="shell buy__inner buy__inner--flip">
        <div className="buy__copy">
          <p className="kicker">Genuine software</p>
          <h2>Start fresh with the right accounting software</h2>
          <p className="buy__sub">Desktop and cloud editions — installed and set up by experts</p>
          <p>
            Buy a publisher-issued licence and let one of our experts install it, set up your
            chart of accounts and move your data across — so day one starts clean.
          </p>
          <p className="buy__fineprint">
            Every licence includes a 60-day money-back guarantee from the software publisher.
          </p>

          <div className="buy__actions">
            <a href="#shop" className="btn btn--green">
              <Icon name="cart" size={18} />
              See all editions
            </a>
            <a href={SUPPORT_PHONE_TEL} className="btn btn--green-line">
              <Icon name="phone" size={18} />
              {SUPPORT_PHONE_LABEL}
            </a>
            <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
              <Icon name="chat" size={18} />
              Help me choose
            </button>
          </div>

          <a className="buy__link" href="#consultation">
            Not sure which edition fits your business? Ask an expert first
          </a>
        </div>

        <figure className="buy__visual">
          <img
            src="/images/buy-accounting-desk.webp"
            alt="Accounting dashboard open on a desktop computer at a tidy office desk"
            width="1100"
            height="825"
            loading="lazy"
            decoding="async"
          />
          <figcaption className="buy__badge">
            <i className="buy__dot" aria-hidden="true" />
            100% genuine keys
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
